import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M22 17v-3h-20","key":"svg-1"}],["path",{"d":"M2 8v9","key":"svg-2"}],["path",{"d":"M12 14h10v-2a3 3 0 0 0 -3 -3h-7v5z","key":"svg-3"}]]

const IconBed = createReactComponent('outline', 'bed', 'Bed', __iconNode);

export default IconBed;